/**
 * 处理 topic 数据的嵌套结构
 * 后端返回的 topic 可能有两种结构：
 * 1. 直接的 topic 对象
 * 2. 包含 statistics 和 topic 的嵌套对象
 */
export function extractTopicData(topicData: any) {
  if (!topicData) {
    return null;
  }

  // 如果有嵌套的 topic 属性，提取实际的题目数据
  if (topicData.topic && typeof topicData.topic === 'object') {
    return topicData.topic;
  }

  // 否则返回原始数据
  return topicData;
}

/**
 * 从 essay 对象中提取 topic 数据
 */
export function getTopicFromEssay(essay: any) {
  if (!essay) {
    return null;
  }

  // 尝试不同的属性名（topic 或 Topic）
  const topicData = essay.topic || essay.Topic;
  return extractTopicData(topicData);
}